import { FC, useEffect, useState } from 'react';
import { useRevenuePools } from '../../../hooks/useRevenuePools';
import { UseTranslationResponse } from 'react-i18next';
import { Autocomplete, TextField } from '@mui/material';
import { useFormikContext } from 'formik';

interface SearchItem {
  label: string;
  id: string;
}

const fieldName = 'rentalDetails.revenuePool';

interface Props {
  t: UseTranslationResponse<any>;
}

export const RevenuePoolAutocompleteField: FC<Props> = ({ t }) => {
  const formik = useFormikContext();
  const [value, setValue] = useState<SearchItem | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const revenuePools = useRevenuePools({ title: searchTerm, rowsPerPage: 5 }, t);
  const revenuePoolItems: SearchItem[] = revenuePools.items.map((pool) => ({ label: pool.title, id: pool._id || '' }));

  useEffect(() => {
    const revenuePool = formik.getFieldProps(fieldName).value;
    // only update if object, otherwise it would also be updated if 'rentalDetails.revenuePool' is just the id, not the object (on update)
    if (typeof revenuePool === 'object') {
      const val = { label: revenuePool.title, id: revenuePool._id };
      setValue(val);
      formik.setFieldValue(fieldName, val.id);
    }
  }, []);

  return (
    <Autocomplete
      disablePortal
      value={value}
      options={revenuePoolItems}
      onInputChange={(e, val) => setSearchTerm(val)}
      onChange={(e, val) => {
        setValue(val);
        formik.setFieldValue(fieldName, val?.id);
      }}
      renderInput={(params) => <TextField {...params} label={t('dashboard.assets.addedit.main.rentalincome.text.revenuePool')} />}
    />
  );
};
